// ── Upload gating statuses (two allowed values) ──
// The em dash (U+2014) is intentional — do NOT replace with a hyphen.
export const UPLOAD_ALLOWED_STATUSES = [
  "Pending at Central Dashboard",
  "Collection Rejected \u2014 Pending at Central Dashboard",
];

// ── Collection Updation editable statuses (identical list) ──
export const EDITABLE_STATUSES = [
  "Pending at Central Dashboard",
  "Collection Rejected \u2014 Pending at Central Dashboard",
];

// ── Approval-resolution statuses (set by COps "Send for Approval") ──
export const STATUS_PENDING_COPS_HEAD =
  "Pending Approval \u2014 COps Head";
export const STATUS_APPROVED_COPS_FINANCE =
  "Approved by COps \u2014 Pending at Finance";
export const STATUS_APPROVED_COPS_INSURANCE =
  "Approved by COps \u2014 Pending at Insurance";

// ── Loss type dropdown options ──
export const LOSS_TYPE_OPTIONS = [
  "Insurance Loss",
  "BD Loss",
  "City Loss",
  "Cops Loss",
  "MD Team Loss",
  "Patient level Gap Loss",
  "Hospital Error Loss",
  "Removal Waiver",
];

// ── GHV payment-mode options ──
export const PAYMENT_MODE_OPTIONS = [
  "Cash",
  "UPI",
  "NEFT",
  "PayU",
  "Razorpay",
  "EMI",
  "Card",
  "Cheque",
];

// ── Image extension regex ──
export const IMAGE_EXT_REGEX = /\.(png|jpe?g|gif|bmp|webp|svg)(\?|#|$)/i;

// ── PDF viewer hash params ──
export const PDF_VIEWER_HASH =
  "#toolbar=1&navpanes=0&pagemode=none&view=FitH";

// ── Helpers ──
export const isUploadAllowed = (collectionStatus) =>
  UPLOAD_ALLOWED_STATUSES.includes(collectionStatus);

// Override gate: upload is also allowed when the central final-bill status is
// exactly "Approved" AND the finance final-bill status is exactly "Declined".
export const isFbStatusOverrideAllowed = (isCentralFBStatus, isFinanceFBStatus) =>
  isCentralFBStatus === "Approved" && isFinanceFBStatus === "Declined";

// Combined upload gate used by the modal: allowed when the collection status is
// one of the allowed statuses OR the final-bill status override applies.
export const isUploadEnabled = (collectionStatus, isCentralFBStatus, isFinanceFBStatus) =>
  isUploadAllowed(collectionStatus) ||
  isFbStatusOverrideAllowed(isCentralFBStatus, isFinanceFBStatus);

export const isCashPayment = (paymentMode) =>
  paymentMode?.trim()?.toLowerCase() === "cash";

// Mirror the central dashboard's actual logic (collection-updation.component.ts):
//   loss present AND non-cash  -> Pending at Insurance
//   otherwise (any other case) -> Pending at Finance
// (STATUS_PENDING_COPS_HEAD is intentionally NOT used by the central code.)
export const resolveApprovalStatus = (hasLoss, isCash) => {
  if (hasLoss && !isCash) return STATUS_APPROVED_COPS_INSURANCE;
  return STATUS_APPROVED_COPS_FINANCE;
};
